import { useMemo } from 'react';
import { DonutChart, MappingList } from '@silverfort/sf-components';
import { DonutChartData } from '@silverfort/sf-components/dist/Charts/DonutChart/types';
import { splitArrayIntoBatches } from '../../../utils';

const DEFAULT_CHART_SIZE = 100;
const DEFAULT_BATCH_SIZE = 4;

type UsePaginatedDonutChartProps = {
    chartData: DonutChartData[];
    isLoading: boolean;
    chartSize?: number;
    batchSize?: number;
    innerCircleEmptyStateClassName?: string;
};

const usePaginatedDonutChart = ({
    chartData,
    isLoading,
    chartSize = DEFAULT_CHART_SIZE,
    batchSize = DEFAULT_BATCH_SIZE,
    innerCircleEmptyStateClassName = ''
}: UsePaginatedDonutChartProps) => {
    const batches = useMemo(() => splitArrayIntoBatches(chartData, batchSize), [chartData, batchSize]);

    const pages = useMemo(() => {
        if (!batches.length) return [
            <div className="flex w-[100%] flex-row justify-center gap-8 px-4 h-full">
                <div className="flex w-[30%] flex-shrink-0 items-center justify-center min-h-[100px]">
                    <DonutChart data={[]} isMappingVisible={false} isLoading={isLoading} chartSize={chartSize} innerCircleEmptyStateClassName={innerCircleEmptyStateClassName}/>
                </div>
                <div className="flex-1 min-h-[100px] flex items-center">
                    <MappingList items={[]} isLoading={isLoading} />
                </div>
            </div>
        ];;

        return batches.map((items) => (
            <div className="flex w-[100%] flex-row justify-center gap-8 px-4 h-full">
                <div className="flex w-[30%] flex-shrink-0 items-center justify-center min-h-[100px]">
                    <DonutChart data={chartData} isMappingVisible={false} isLoading={isLoading} chartSize={chartSize} innerCircleEmptyStateClassName={innerCircleEmptyStateClassName}/>
                </div>
                <div className="flex-1 min-h-[100px] flex items-center">
                    <MappingList items={items} isLoading={isLoading} />
                </div>
            </div>
        ));
    }, [batches, chartData, isLoading, chartSize, innerCircleEmptyStateClassName]);

    return pages;
};

export default usePaginatedDonutChart;
